import { render } from "./GoalProgressCircle.vue?vue&type=template&id=034db0aa&scoped=true"
import script from "./GoalProgressCircle.vue?vue&type=script&lang=js"
export * from "./GoalProgressCircle.vue?vue&type=script&lang=js"

import "./GoalProgressCircle.vue?vue&type=style&index=0&id=034db0aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034db0aa"]])

export default __exports__